/* eslint-disable camelcase */
export const OTP_CONSTANT = {
  success: {
    status: 'Request Sent',
    message:
      'Kindly inform your immediate supervisor about your registration to the HR Online Clearance and have him/her approve your request.',
    buttonMsg: 'Close',
  },
  error: {
    status: 'Request Failed',
    message: 'Incorrect OTP Entered.',
    buttonMsg: 'Try Again',
  },
}
